﻿import React from "react";
import { styled } from "@mui/material/styles";
import { CardItemValue } from "../CardItemValue";

const Root = styled(CardItemValue)(({ theme }) => ({
  color: theme.palette.error.main,
}));

type CardItemValueErrorProps = React.ComponentPropsWithoutRef<'span'>;

const CardItemValueError = (props: CardItemValueErrorProps) => {
  return <Root {...props} />
}

export { CardItemValueError }